import * as React from 'react'
import {Container} from './Container'

export interface BreadcrumbItem {
    title: string
    url?: string
}

export interface BreadcrumbProps {
    items: BreadcrumbItem[]
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
    if (!items || items.length <= 1) return null

    const parent = items[items.length - 2]

    return (
        <div className="pt-6 md:pt-8">
            <Container>
                <nav aria-label="Brødsmuler" className="col-span-full">
                    {/* Mobile: single back link to parent */}
                    <a
                        href={parent.url}
                        className="inline-flex items-center gap-1 font-sans text-base tracking-wide leading-snug text-slate-700 hover:underline focus-visible:outline focus-visible:outline-1 focus-visible:outline-slate-300 md:hidden"
                    >
                        <span aria-hidden="true">←</span>
                        {parent.title}
                    </a>
                    {/* Desktop: full breadcrumb */}
                    <ol className="hidden items-center gap-2 font-sans text-lg tracking-wide leading-snug md:flex">
                        {items.map((item, index) => {
                            const isLast = index === items.length - 1
                            return (
                                <li key={index} className="flex items-center gap-2">
                                    {index > 0 && (
                                        <span className="text-slate-700" aria-hidden="true">/</span>
                                    )}
                                    {isLast ? (
                                        <span className="text-black" aria-current="page">
                                            {item.title}
                                        </span>
                                    ) : (
                                        <a
                                            href={item.url}
                                            className="text-slate-700 hover:underline focus-visible:outline focus-visible:outline-1 focus-visible:outline-slate-300"
                                        >
                                            {item.title}
                                        </a>
                                    )}
                                </li>
                            )
                        })}
                    </ol>
                </nav>
            </Container>
        </div>
    )
}
